const ReviewsSlider = new Swiper(".reviews__slider", {
  slidesPerView: 2.75,
  spaceBetween: 39,
  loop: true,
  navigation: {
    nextEl: ".reviews .reviews__nav--next",
    prevEl: ".reviews .reviews__nav--prev",
  },
  breakpoints: {
    0: {
      slidesPerView: 1,
    },
    750: {
      slidesPerView: 2,
    },
    990: {
      slidesPerView: 2.75,
      spaceBetween: 20,
    },
    1441: {
      slidesPerView: 2.75,
      spaceBetween: 39,
    },
  },
});